import * as __WEBPACK_EXTERNAL_MODULE__AccordionContent_js_8b0db393__ from "./AccordionContent.js";
import * as __WEBPACK_EXTERNAL_MODULE__AccordionItem_js_f5ab4647__ from "./AccordionItem.js";
import * as __WEBPACK_EXTERNAL_MODULE__AccordionRoot_js_d86509d7__ from "./AccordionRoot.js";
import * as __WEBPACK_EXTERNAL_MODULE__AccordionTrigger_js_fade37a8__ from "./AccordionTrigger.js";
const Accordion = {
    Root: __WEBPACK_EXTERNAL_MODULE__AccordionRoot_js_d86509d7__.AccordionRoot,
    Item: __WEBPACK_EXTERNAL_MODULE__AccordionItem_js_f5ab4647__.AccordionItem,
    Trigger: __WEBPACK_EXTERNAL_MODULE__AccordionTrigger_js_fade37a8__.AccordionTrigger,
    Content: __WEBPACK_EXTERNAL_MODULE__AccordionContent_js_8b0db393__.AccordionContent
};
const Accordion_rslib_entry_ = Accordion;
export { Accordion_rslib_entry_ as default };

//# sourceMappingURL=index.js.map